import { Text, Heading, TextEnum, HeadingEnum, BoldEnum, TextColorEnum } from '@desquared/wave-components-library';
import styles from './CategoryTitle.module.css';

export default function CategoryTitle({ title, subtitle }) {
  return (
    <div>
      <Heading type={HeadingEnum.HeadingM} bold={BoldEnum.Bold} classOption={styles.title}>
        {title}
      </Heading>
      {subtitle && (
        <Text type={TextEnum.Assistive} color={TextColorEnum.Gray1}>
          {subtitle}
        </Text>
      )}
    </div>
  );
}
